import React from 'react';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import './Department.css';

const Service: React.FC = () => {
  return (
    <div className="department-page">
      <Header />
      <div className="department-container">
        <div className="department-header">
          <h1>Service Department</h1>
          <p className="department-description">
            Welcome to the Service Department page. Here you can find service information, 
            maintenance schedules, and customer service resources.
          </p>
        </div>
        <div className="department-content">
          <div className="department-card">
            <h3>About Service Department</h3>
            <p>
              The Service Department is responsible for providing after-sales service, maintenance, 
              repairs, and ensuring customer satisfaction through excellent service delivery.
            </p>
          </div>
          <div className="department-card">
            <h3>Key Functions</h3>
            <ul>
              <li>Vehicle Maintenance</li>
              <li>Repair Services</li>
              <li>Customer Service</li>
              <li>Service Scheduling</li>
              <li>Quality Assurance</li>
              <li>Technical Support</li>
            </ul>
          </div>
          <div className="department-card">
            <h3>Contact Information</h3>
            <p>For service-related inquiries, please contact the Service Department.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Service;

